import { render, staticRenderFns } from "./LoginFormResetPassword.vue?vue&type=template&id=455a014a"
import script from "./LoginFormResetPassword.vue?vue&type=script&lang=js"
export * from "./LoginFormResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports